import React from 'react';
import Header from '../components/Header';
import FooterComponent from '../components/FooterComponent';

const Terms = () => {
  return (
    <div className='min-h-screen bg-base-200'>
      <Header />
      <div className='max-w-4xl mx-auto py-16 px-4'>
        <h1 className='text-4xl font-bold mb-2'>Terms and Conditions</h1>
        <p className='text-base-content/60 mb-8'>Last updated: March 5, 2026</p>

        <div className='space-y-8 text-base-content/80'>
          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>1. ACCEPTANCE OF TERMS</h2>
            <p>By creating an account on Beanbag ("the App"), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not access or use the App.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>2. ELIGIBILITY</h2>
            <p>You must be at least 18 years old to use Beanbag. By registering, you confirm that you are 18 or older and have the legal capacity to enter into a binding agreement.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>3. USER ACCOUNTS</h2>
            <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately at <a href='mailto:joaopedro.soares57609@gmail.com' className='link link-primary'>joaopedro.soares57609@gmail.com</a> if you suspect unauthorized access.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>4. ACCEPTABLE USE</h2>
            <p>You agree not to use Beanbag to:</p>
            <ul className='list-disc list-inside space-y-2 mt-4'>
              <li>Harass, abuse, threaten, or harm other users.</li>
              <li>Post content that is offensive, discriminatory, sexually explicit, or illegal.</li>
              <li>Impersonate any person or entity or misrepresent your affiliation with a person or entity.</li>
              <li>Spam, phish, or distribute malicious software.</li>
              <li>Scrape, crawl, or otherwise extract data from the App without prior written consent.</li>
              <li>Interfere with or disrupt the integrity or performance of the App or its servers.</li>
            </ul>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>5. CONTENT OWNERSHIP</h2>
            <p>You retain ownership of any content you submit to the App (e.g., profile photos, bio). By submitting content, you grant Beanbag a worldwide, non-exclusive, royalty-free license to use, display, and distribute that content solely for operating and improving the App.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>6. MATCHING & COMMUNICATION</h2>
            <p>Beanbag facilitates connections between gamers. We do not guarantee matches, compatibility, or the accuracy of other users' information. Any meeting or communication that occurs as a result of a match on Beanbag is entirely at your own risk.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>7. PROHIBITED CONTENT</h2>
            <p>You must not upload or share content that infringes on the intellectual property rights of others, including game assets, trademarks, or copyrighted material, unless you have the necessary rights or permissions.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>8. TERMINATION</h2>
            <p>We reserve the right to suspend or terminate your account at any time, with or without notice, if you violate these Terms or if we determine that your conduct is harmful to other users, to us, or to third parties.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>9. DISCLAIMERS</h2>
            <p>The App is provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. We do not warrant that the App will be uninterrupted, error-free, or free of harmful components.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>10. LIMITATION OF LIABILITY</h2>
            <p>To the fullest extent permitted by law, Beanbag and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the App.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>11. INDEMNIFICATION</h2>
            <p>You agree to indemnify and hold harmless Beanbag, its operators, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the App or your violation of these Terms.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>12. CHANGES TO THESE TERMS</h2>
            <p>We may update these Terms from time to time. Continued use of the App after changes are posted constitutes acceptance of the updated Terms. We will notify users of significant changes via the App or by email.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>13. GOVERNING LAW</h2>
            <p>These Terms shall be governed by and construed in accordance with applicable laws. Any disputes shall be resolved through binding arbitration or in the courts of competent jurisdiction.</p>
          </section>

          <section>
            <h2 className='text-2xl font-bold text-base-content mb-4'>14. CONTACT US</h2>
            <p>If you have questions about these Terms, please contact us at:</p>
            <p className='mt-2'>Email: <a href='mailto:joaopedro.soares57609@gmail.com' className='link link-primary'>joaopedro.soares57609@gmail.com</a></p>
          </section>
        </div>

        <div className='mt-12 pt-8 border-t border-base-content/20 text-center text-base-content/60'>
          <p>© 2026 Beanbag. All rights reserved.</p>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
};

export default Terms;